export var API_PATH;
(function (API_PATH) {
    API_PATH["QUERY_INTENTION"] = "/api/altas/marketing/query/userTag";
})(API_PATH || (API_PATH = {}));
export var ScoreType;
(function (ScoreType) {
    ScoreType["HotelScore"] = "1";
    ScoreType["TicketScore"] = "2";
    ScoreType["VacationScore"] = "3";
    ScoreType["TrafficScore"] = "4";
})(ScoreType || (ScoreType = {}));
export var TravelServiceType;
(function (TravelServiceType) {
    TravelServiceType["Hotel"] = "1";
    // 酒店
    TravelServiceType["Flight"] = "2";
    // 机票
    TravelServiceType["Train"] = "3";
    // 火车票
    TravelServiceType["Ticket"] = "5";
    // 门票
    TravelServiceType["Vacation"] = "6"; // 度假
})(TravelServiceType || (TravelServiceType = {}));
